<div class="flex flex-col fill justify-between user-management-page">
  <div class="flex flex-col">
    <h2 class="page-title page-header-spacing">{{ this.translationService.translate('userGroupInformationText') }}</h2>
    <form
      [formGroup]="userGroupForm"
      class="filters flex flex-row justify-start items-start sm-flex-col gap-4 user-management-filters"
      (ngSubmit)="validateAndSaveUserGroup()"
    >
      <mat-form-field class="search-by-name-input editable-field" [class.readonly-field]="groupId !== ''" subscriptSizing="dynamic">
        <mat-label>{{ this.translationService.translate('userGroupNameText') }}</mat-label>
        <input
          matInput
          type="text"
          [formControlName]="'userGroupName'"
          placeholder="{{ translationService.translate('enterTheUserGroupNameText') }}"
          required
          [readonly]="groupId !== ''"
        />
        @if (userGroupForm.get('userGroupName').hasError('required')) {
        <mat-error class="custom-error" id="user-group-error">
          {{ translationService.translate('mandatoryFieldText') }}
        </mat-error>
        } @if (userGroupForm.get('userGroupName').hasError('userGroupNameExists')) {
        <mat-error class="custom-error" id="user-group-exists-error">
          {{ translationService.translate('userGroupNameAlreadyExistsText') }}
        </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="flex-1 editable-field" subscriptSizing="dynamic">
        <mat-label>{{ this.translationService.translate('userGroupDescriptionText') }}</mat-label>
        <input
          matInput
          type="text"
          [formControlName]="'userGroupDesc'"
          placeholder="{{ this.translationService.translate('userGroupDescriptionText') }}"
        />
      </mat-form-field>
      <div class="flex flex-row flex-1 gap-4 justify-end user-management-actions">
        <button mat-flat-button class="btn-cancel" [hidden]="true">
          <mat-icon>arrow_back</mat-icon>
          {{ this.translationService.translate('backButtonText') }}
        </button>
        <button mat-flat-button class="btn-primary" color="primary" [loading]="saving" type="submit">
          <mat-icon>save</mat-icon>
          {{ this.translationService.translate('saveLinkText') }}
        </button>
      </div>
    </form>
  </div>
  <mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="groupPermissionsLoading || saving"></mic-spinner-overlay>

  <h2 class="page-title page-header-spacing">{{ translationService.translate('userGroupPermissionText') }}</h2>

  <!--Shop floor and General Permission start here -->
  @for (group of permissionGroupList; track $index; let i = $index) {
  <mat-accordion hideToggle style="margin-bottom: 20px">
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header class="section-header-style">
        <mat-panel-title>
          {{ translationService.translate(group.label) }}
        </mat-panel-title>
        <div class="flex flex-row flex-1 gap-4 justify-end section-header-title">
          {{ this.translationService.translate('activateAllText') }}
          <mat-slide-toggle
            [checked]="isAllPermissionsChecked(group.permissions)"
            class="section-header-title"
            style="margin-right: 20px"
            (change)="activateAllPermissions(group.permissions, $event.checked)"
            (click)="$event.stopPropagation()"
            >{{ this.translationService.translate(isAllPermissionsChecked(group.permissions) ? 'yesText' : 'noText') }}
          </mat-slide-toggle>
        </div>
      </mat-expansion-panel-header>
      <mat-divider></mat-divider>
      @for (item of group.permissions; track $index; let i = $index) {
      <div class="row" style="margin-top: 10px">
        <div class="column section-border">
          <div class="row">
            <div class="column">
              @if (item.id !== 0) {
              <mat-label
                class="flex flex-row flex-1 gap-4 justify-start"
                style="margin-left: 10px"
                [ngClass]="{ 'required-label': isEmptyUserGroup }"
                >{{ this.translationService.translate(item.leftSideLabel) }}
              </mat-label>
              }
            </div>
            <div class="column">
              @if (item.id === 0) {
              <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
                >{{ this.translationService.translate(item.leftSideLabel) }}
              </mat-label>
              } @if (item.id !== 0) {
              <mat-checkbox
                class="flex flex-row flex-1 gap-4 justify-end"
                [checked]="item.isCheckedLeftBox"
                (change)="onPermissionChange(item, true, $event.checked)"
                [ngClass]="{ 'required-checkbox': isEmptyUserGroup }"
              ></mat-checkbox>
              }
            </div>
          </div>
        </div>
        <div class="column">
          <div class="row">
            <div class="column">
              @if (item.id !== 0) {
              <mat-label
                class="flex flex-row flex-1 gap-4 justify-start"
                style="margin-left: 10px"
                [ngClass]="{ 'required-label': isEmptyUserGroup }"
                >{{ this.translationService.translate(item.rightSideLabel) }}
              </mat-label>
              }
            </div>
            <div class="column">
              @if (item.id === 0) {
              <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
                >{{ this.translationService.translate(item.rightSideLabel) }}
              </mat-label>
              } @if (item.id !== 0 && item.rightSideLabel !== '') {
              <mat-checkbox
                class="flex flex-row flex-1 gap-4 justify-end"
                [checked]="item.isCheckedRightBox"
                (change)="onPermissionChange(item, false, $event.checked)"
                [ngClass]="{ 'required-checkbox': isEmptyUserGroup }"
              ></mat-checkbox>
              }
            </div>
          </div>
        </div>
      </div>
      }
    </mat-expansion-panel>
  </mat-accordion>
  }
  <mat-accordion hideToggle>
    <mat-expansion-panel [expanded]="true">
      <mat-expansion-panel-header class="section-header-style">
        <mat-panel-title>
          {{ translationService.translate('backofficePermissionsText') }}
        </mat-panel-title>
        <div class="flex flex-row flex-1 gap-4 justify-end section-header-title">
          {{ this.translationService.translate('activateAllText') }}
          <mat-slide-toggle
            [checked]="isAllBackOfficePermissionsChecked()"
            class="section-header-title"
            style="margin-right: 20px"
            (change)="activateAllBackOfficePermissions($event.checked)"
            (click)="$event.stopPropagation()"
            >{{ this.translationService.translate(isAllBackOfficePermissionsChecked() ? 'yesText' : 'noText') }}
          </mat-slide-toggle>
        </div>
      </mat-expansion-panel-header>
      <mat-divider></mat-divider>
      @for (item of backOfficePermissions; track $index; let i = $index) {
      <div class="row" style="margin-top: 10px">
        <div class="column">
          @if (item.id !== 0) {
          <mat-label
            class="flex flex-row flex-1 gap-4 justify-start"
            style="margin-left: 10px"
            [ngClass]="{ 'required-label': isEmptyUserGroup }"
            >{{ this.translationService.translate(item.leftSideLabel) }}
          </mat-label>
          }
        </div>
        <div class="column flex flex-row flex-1 gap-4 justify-start"></div>
        <div class="column">
          @if (item.id === 0) {
          <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title" style="margin-left: 10px"
            >{{ this.translationService.translate('allText') }}
          </mat-label>
          } @if (item.id !== 0) {
          <mat-checkbox
            class="flex flex-row flex-1 gap-4 justify-end"
            [checked]="item.isAllChecked"
            (change)="onBackOfficePermissionChange(item, 'all', $event.checked)"
            [ngClass]="{ 'required-checkbox': isEmptyUserGroup }"
          ></mat-checkbox>
          }
        </div>
        <div class="column">
          @if (item.id === 0) {
          <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
            >{{ this.translationService.translate('viewText') }}
          </mat-label>
          } @if (item.id !== 0) {
          <mat-checkbox
            class="flex flex-row flex-1 gap-4 justify-end"
            [checked]="item.isViewChecked"
            (change)="onBackOfficePermissionChange(item, 'view', $event.checked)"
            [ngClass]="{ 'required-checkbox': isEmptyUserGroup }"
            [disabled]="item.leftSideLabelKey === 'PROFILE_SETUP'"
          >
          </mat-checkbox>
          }
        </div>
        <div class="column">
          @if (item.id === 0) {
          <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
            >{{ this.translationService.translate('editLinkText') }}
          </mat-label>
          } @if (item.id !== 0) {
          <mat-checkbox
            class="flex flex-row flex-1 gap-4 justify-end"
            [checked]="item.isEditChecked"
            (change)="onBackOfficePermissionChange(item, 'edit', $event.checked)"
            [ngClass]="{ 'required-checkbox': isEmptyUserGroup }"
            [disabled]="item.leftSideLabelKey === 'PROFILE_SETUP'"
          >
          </mat-checkbox>
          }
        </div>
        <div class="column">
          @if (item.id === 0) {
          <mat-label class="flex flex-row flex-1 gap-4 justify-start section-header-title"
            >{{ this.translationService.translate('createButtonText') }}
          </mat-label>
          } @if (item.id === 1) {
          <mat-checkbox
            class="flex flex-row flex-1 gap-4 justify-end"
            [checked]="item.isCreateChecked"
            (change)="onBackOfficePermissionChange(item, 'create', $event.checked)"
            [ngClass]="{ 'required-checkbox': isEmptyUserGroup }"
          ></mat-checkbox>
          }
        </div>
      </div>
      }
    </mat-expansion-panel>
  </mat-accordion>
  <div class="audit-container">
    @if (groupId) {
    <p id="audit-modified">
      {{ this.translationService.translate('lastUpdatedText') }} UTC : {{ lastUpdatedTimestamp }}
      {{ this.translationService.translate('byText') }} {{ lastUpdatedBy }}
    </p>
    } @if (groupId) {
    <p id="audit-created">
      {{ this.translationService.translate('createButtonText') }} UTC : {{ createdTimestamp }}
      {{ this.translationService.translate('byText') }} {{ createdBy }}
    </p>
    }
  </div>
  <ng-template #unsavedConfirmation>{{ this.translationService.translate('unSaveChangesText') }}</ng-template>
  <mic-modal class="modalC" #unsavedChangesModal></mic-modal>
</div>
